export default __webpack_public_path__ + "static/media/lock-filled.f96ad602.svg";